import * as React from 'react'

import { Input } from '~/client/src/shared/components/shadcn-ui/input'

interface IProps {
  id: string
  name: string
  placeholder: string
  onCommit(name: string): void
}

// Commits on blur or Enter, so the name lands as one change rather than one per keystroke.
const RuleNameInput: React.FC<IProps> = ({
  id,
  name,
  placeholder,
  onCommit,
}) => {
  const [value, setValue] = React.useState(name ?? '')

  React.useEffect(() => {
    setValue(name ?? '')
  }, [name])

  const commit = () => {
    if (value.trim() !== (name ?? '')) {
      onCommit(value)
    }
  }

  return (
    <Input
      id={id}
      className="tw:h-8 tw:w-full"
      value={value}
      placeholder={placeholder}
      onChange={event => setValue(event.target.value)}
      onBlur={commit}
      onKeyDown={event => {
        if (event.key === 'Enter') {
          event.currentTarget.blur()
        }
      }}
    />
  )
}

export default RuleNameInput
